function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M76.75 11.025a2 2 0 012-2h56.167a2 2 0 012 2v38.117a2 2 0 01-2 2H78.75a2 2 0 01-2-2V11.025z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M76.75 11.025a2 2 0 012-2h56.167a2 2 0 012 2v38.117a2 2 0 01-2 2H78.75a2 2 0 01-2-2V11.025z",
  stroke: "url(#devices_svg__paint0_linear_1515_3507)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M94.8 63.175h24.066",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M94.8 63.175h24.066",
  stroke: "url(#devices_svg__paint1_linear_1515_3507)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M106.833 51.142v12.033",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M106.833 51.142v12.033",
  stroke: "url(#devices_svg__paint2_linear_1515_3507)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M158.917 62.667a2 2 0 01-2-2V35.333a2 2 0 012-2h35.167a2 2 0 012 2v25.334a2 2 0 01-2 2h-35.167z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M158.917 62.667a2 2 0 01-2-2V35.333a2 2 0 012-2h35.167a2 2 0 012 2v25.334a2 2 0 01-2 2h-35.167z",
  stroke: "url(#devices_svg__paint3_linear_1515_3507)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 8.875,
  y: 24.5,
  width: 45.25,
  height: 29.5,
  rx: 2,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 8.875,
  y: 24.5,
  width: 45.25,
  height: 29.5,
  rx: 2,
  stroke: "url(#devices_svg__paint4_linear_1515_3507)",
  strokeWidth: 2
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M3.625 61.875h55.75"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#devices_svg__paint5_linear_1515_3507)",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M3.625 61.875h55.75"
});
var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint0_linear_1515_3507",
  x1: 106.833,
  y1: 9.025,
  x2: 106.833,
  y2: 51.142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint1_linear_1515_3507",
  x1: 106.833,
  y1: 63.175,
  x2: 106.833,
  y2: 66.183,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint2_linear_1515_3507",
  x1: 108.337,
  y1: 51.142,
  x2: 108.337,
  y2: 63.175,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint3_linear_1515_3507",
  x1: 156.917,
  y1: 48,
  x2: 196.084,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint4_linear_1515_3507",
  x1: 31.5,
  y1: 23.5,
  x2: 31.5,
  y2: 55,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "devices_svg__paint5_linear_1515_3507",
  x1: 31.5,
  y1: 62.875,
  x2: 31.5,
  y2: 63.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));
function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
export default SvgDevices;